module.exports = __webpack_public_path__ + "img/diagnosis-framework.02262102.png";